// Variables de contenedor GTM
export const GTM_CODE_DEV = 'GTM-M973827';
export const GTM_CODE_PROD = 'GTM-T47852Z';

export const PAGEVIEW = {
  siteChannelApp: {
    path: 'site.channel',
    value: 'SuperAppPF',
  },
  siteChannelWeb: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  developmenttype: {
    path: 'site.developmenttype',
    value: null,
  },
  environment: {
    path: 'site.environment',
    value: null,
  },
  useragent: {
    path: 'site.useragent',
    value: null,
  },
  permissions: {
    path: 'site.permissions',
    value: null,
  },
  accessibility: {
    path: 'site.accessibility',
    value: null,
  },
  geolocation: {
    path: 'visitor.geolocation',
    value: null,
  },
  // PPID para clientes persona natural
  clientIdpf: {
    path: 'visitor.client.idpf',
    value: null,
  },
  clientAccounttype: {
    path: 'visitor.client.accounttype',
    value: null,
  },
  clientAgency: {
    path: 'visitor.client.agency',
    value: null,
  },
  clientCommercialsegment: {
    path: 'visitor.client.commercialsegment',
    value: null,
  },
  clientDeclaredincomerange: {
    path: 'visitor.client.declaredincomerange',
    value: null,
  },
  clientLimitusage: {
    path: 'visitor.client.limitusage',
    value: null,
  },
  clientLoannearduedate: {
    path: 'visitor.client.loannearduedate',
    value: null,
  },
  clientOccupation: {
    path: 'visitor.client.occupation',
    value: null,
  },
  clientProfile: {
    path: 'visitor.client.profile',
    value: null,
  },
  clientRewardsprogram: {
    path: 'visitor.client.rewardsprogram',
    value: null,
  },
  clientScore: {
    path: 'visitor.client.score',
    value: null,
  },
  clientStars: {
    path: 'visitor.client.stars',
    value: null,
  },
  clientTitularitycode: {
    path: 'visitor.client.titularitycode',
    value: null,
  },
  clientType: {
    path: 'visitor.client.type',
    value: null,
  },
  clienClientrewardsvaluerange: {
    path: 'visitor.client.clientrewardsvaluerange',
    value: null,
  },
  clientContracteddigitalproducts: {
    path: 'visitor.client.contracteddigitalproducts',
    value: null,
  },

  // Pantallas de aprobado en firme - multiproducto
  // Pantalla 1
  pv1pageName: {
    path: 'page.name',
    value: 'OfertaAprobadosEnFirme',
  },
  pv1pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv1subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv1pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv1pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv1internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv1errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv1transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv1transactionName: {
    path: 'transaction.name',
    value: 'Solicitud',
  },

 // Pantalla 2
  pv2pageName: {
    path: 'page.name',
    value: 'ConocerMasAprobadosEnFirme',
  },
  pv2pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv2subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv2pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv2pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv2internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv2errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv2transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv2transactionName: {
    path: 'transaction.name',
    value: 'Solicitud',
  },
  pv2transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },

};

export const EVENT = {
  customCategory: {
    module: {
      body: 'Body',
      carousel: 'Carousel',
      footer: 'Footer',
      header: 'Header',
      lightbox: 'Lightbox',
      menu: 'Menu',
    },
    type: {
      accordion: 'Accordion',
      arrow: 'Arrow',
      button: 'Button',
      card: 'Card',
      checkbox: 'Checkbox',
      dropdown: 'Dropdown',
      image: 'Image',
      link: 'Link',
      pagination: 'Pagination',
      radio: 'Radio',
      tab: 'Tab',
      textField: 'TextField',
      tooltip: 'Tooltip',
      warning: 'Warning',
    },
    position: {
      bottom: 'Bottom',
      center: 'Center',
      left: 'Left',
      rigt: 'Right',
      top: 'Top',
    },
  },
  customAction: {
    click: 'Click',
    close: 'Close',
    download: 'Download',
    hide: 'Hide',
    open: 'Open',
    print: 'Print',
    scroll: 'Scroll',
    search: 'Search',
    share: 'Share',
    show: 'Show',
    swipeToLeft: 'SwipeToLeft',
    swipeToRigth: 'SwipeToRigth',
  },

  // Eventos pantallas aprobados en firme - Multiproducto
  // Pantalla 1
  pv1E1customLabel: null,
  pv1E1setData: {
    pv1E1transactionName: {
      path: 'transaction.name',
      value: 'Solicitud',
    },
    pv1E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
  },

  pv1E2customLabel: null,
  pv1E2setData: {
    pv1E2transactionName: {
      path: 'transaction.name',
      value: 'Solicitud',
    },
    pv1E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
  },

  pv1E3customLabel: 'CalcularTuCouta | CreditoPersonal',
  pv1E3setData: {
    pv1E3transactionName: {
      path: 'transaction.name',
      value: 'Solicitud',
    },
    pv1E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
  },

  pv1E4customLabel: 'Continuar',
  pv1E4setData: {
    pv1E4transactionName: {
      path: 'transaction.name',
      value: 'Solicitud',
    },
    pv1E4transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv1E4transactionDetailProductDetails: {
      path: 'transaction.details.productdetails',
      value: null,
    },
  },

  pv1E5customLabel: 'Volver',
  pv1E5setData: {
    pv1E5transactionName: {
      path: 'transaction.name',
      value: 'Solicitud',
    },
    pv1E5transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
  },

  pv1E6customLabel: 'NoMeInteresa',
  pv1E6setData: {
    pv1E6transactionName: {
      path: 'transaction.name',
      value: 'Solicitud',
    },
    pv1E6transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
  },

  pv1E7customLabel: 'Salir',
  pv1E7setData: {
    pv1E7transactionName: {
      path: 'transaction.name',
      value: 'Solicitud',
    },
    pv1E7transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
  },

  pv1E8customLabel: 'Salir',
  pv1E8setData: {
    pv1E8transactionName: {
      path: 'transaction.name',
      value: 'Solicitud',
    },
    pv1E8transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv1E8clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
  },

  pv1E9customLabel: 'Cancelar',
  pv1E9setData: {
    pv1E9transactionName: {
      path: 'transaction.name',
      value: 'Solicitud',
    },
    pv1E9transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
  },

  // Pantalla 2
  pv2E1customLabel: 'Volver',
  pv2E1setData: {
    pv2E1transactionName: {
      path: 'transaction.name',
      value: 'Solicitud',
    },
    pv2E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
  },

  pv2E2customLabel: null,
  pv2E2setData: {
    pv2E2transactionName: {
      path: 'transaction.name',
      value: 'Solicitud',
    },
    pv2E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
  },

  pv2E3customLabel: 'Salir',
  pv2E3setData: {
    pv2E3transactionName: {
      path: 'transaction.name',
      value: 'Solicitud',
    },
    pv2E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
  },

};

export const COUNTRY = {
  ar: 'AR',
  cl: 'CL',
  co: 'CO',
  oca: 'OCA',
  py: 'PY',
  uy: 'UY',
};

export const BUSINNESS = {
  pf: 'PF',
  pj: 'PJ',
  un: 'UN',
};

export const ENVIRONMENT = {
  loggeado: 'LG',
  noLoggeado: 'NL',
};

export const CHANNEL = {
  apppn: 'APN',
  superapp: 'SA',
  apptarjetas: 'AT',
  homeBanking: 'HB',
  abreCuentas: 'AC',
};

export const FAMILY = {
  commonArea: 'AreaComun',
  care: 'Atendimento',
  campaigns: 'Campanas',
  accounts: 'Cuentas',
  fidelity: 'Fidelidad',
  investments: 'Inversiones',
  payment: 'Pagamentos',
  loan: 'Prestamo',
  insurance: 'Seguros',
  services: 'Servicios',
  cards: 'Tarjetas',
  transfers: 'Transferencias',
};

export const SUBFAMILY = {
  personalAccidents: 'AccidentesPersonales',
  aguinaldoAdvance: 'AdelantoAguinaldo',
  customs: 'Aduana',
  savingsForecast: 'AhorroPrevisionalUdutario',
  savingsScheduled: 'AhorroProgramado',
  feed: 'Alimentacion',
  proxies: 'Apoderados',
  automotive: 'Automotores',
  help: 'Ayuda',
  banksLocais: 'BancosLocais',
  basic: 'Basica',
  beneficiaries: 'Beneficiarios',
  profitCards: 'BeneficioTarjetas',
  boxSavings: 'CajaAhorro',
  juniorSavingsBox: 'CajaAhorroJunior',
  cashiers: 'Cajeros',
  change: 'Cambio',
  captureDocument: 'CapturaDocumento',
  certification: 'Certificacion',
  chat: 'Chat',
  checks: 'Cheques',
  checksFanfold: 'ChequesFanfold',
  tradeExterior: 'ComercioExterior',
  configurationLinking: 'ConfiguracionVinculacion',
  foreignCurrency: 'CorrienteMonedaExtranjera',
  LocalCurrencyStream: 'CorrienteMonedaLocal',
  credit: 'Credito',
  ownAccounts: 'CuentasPropias',
  virtualAccounts: 'CuentasVirtuales',
  debitoAutomatico: 'DebitoAutomatico',
  depositsTermFixed: 'DepositosPlazoFijo',
  digitization: 'Digitalizacion',
  outside: 'Dxterior',
  bill: 'Factura',
  faq: 'FAQ',
  finance: 'Finanzas',
  fonasa: 'Fonasa',
  funds: 'Fondos',
  form: 'Formulario',
  formInitial: 'FormularioInicial',
  turnsIEDE: 'GirosIEDE',
  datacontact: 'DatosContacto',
  mortgage: 'Hipotecarios',
  historicYTaxasCommissions: 'HistoricoComisionesYTaxas',
  HistoricOfUnderstandings: 'HistoricoDeComprovantes',
  home: 'Home',
  incomedata: 'IngresoDatos',
  irpf: 'IRPF',
  itau: 'Itau',
  landingPage: 'LandingPage',
  letterChange: 'LetraDeCambio',
  letterOfRegulation: 'LetrasDeRegulacionMonetaria',
  linkChannelYoutube: 'LinkCanalYoutube',
  limit: 'Limite',
  creditline: 'LineaDeCredito',
  login: 'Login',
  movements: 'Movimientos',
  notification: 'Notificacion',
  offerProducts: 'OfertaProductos',
  paymentsSMS: 'PagosSMS',
  shareholdingInCertificateOfDeposit: 'ParticipacionEnCertificadoDeDeposito',
  finalStep: 'PasoFinal',
  riskProfile: 'PerfilDeRiesgo',
  personal: 'Personales',
  pld: 'PLD',
  preapproved: 'Preaprobado',
  products: 'Productos',
  proposta: 'Proposta',
  promotions: 'Promociones',
  points: 'Puntos',
  recharge: 'Recarga',
  rechargeable: 'Recargable',
  fundraising: 'Recaudadoras',
  registration: 'Registro',
  health: 'Salud',
  security: 'Seguridad',
  self: 'Self',
  services: 'Servicios',
  overdraft: 'Sobregiro',
  request: 'Solicitud',
  surcursales: 'Surcursales',
  tariff: 'Tarifario',
  cards: 'Tarjetas',
  card: 'TarjetaDebito',
  tolls: 'Telepeaje',
  typechange: 'TipoCambio',
  titleWithSectiones: 'TituloConsecciones',
  travel: 'Viajes',
  life: 'Vida',
  view: 'Vista',
  wallet: 'Wallet',
};

export const PRODUCT = {
  open: 'Abrir',
  activate: 'Activar',
  add: 'Agregar',
  schedule: 'Agendar',
  block: 'Bloquear ',
  change: 'Cambiar',
  cancel: 'Cancelar',
  redeem: 'Canjear',
  consult: 'Consultar',
  configure: 'Configurar',
  hire: 'Contratar',
  disable: 'Desabilitar',
  address: 'Direccionar',
  edit: 'Editar',
  remove: 'Eliminar',
  enable: 'Habilitar',
  log: 'Loguear',
  pay: 'Pagar',
  rescue: 'Rescatar',
  recharge: 'Recargar',
  request: 'Solicitar',
  offer: 'Ofertar',
  transfe: 'Transferir',
};
